import { EXPERIMENT_VARIATION } from '../../experiments/model/EXPERIMENT_VARIATION'
import { type ExperimentType } from '../../experiments/model/Experiment.types'
import { type RecommendationServiceType } from '../config/RecommendationServiceType'

import { type RecommendationExperimentServiceIdConfig } from './recommendationExperimentServiceIdConfig'

export const recommendationResolveExperimentServiceId = ({
  experiment,
  serviceId,
  serviceIdConfig,
}: {
  experiment: ExperimentType
  serviceId: RecommendationServiceType
  serviceIdConfig?: RecommendationExperimentServiceIdConfig
}): string => {
  if (!serviceIdConfig || !experiment.isEnabled) {
    return serviceId
  }

  const { variant } = experiment

  if (
    !variant ||
    variant === EXPERIMENT_VARIATION.DEFAULT ||
    !serviceIdConfig.variants.includes(variant)
  ) {
    return serviceId
  }

  return `${serviceId}_${variant}`
}
